import * as React from 'react';
import { Logo } from './Logo';
import { cn } from '../utils/cn';

export interface FooterColumn {
  title: string;
  links: { label: string; href: string }[];
}

export interface FooterProps extends React.HTMLAttributes<HTMLElement> {
  brandName?: string;
  description?: string;
  columns?: FooterColumn[];
  copyright?: string;
}

/**
 * Sötét lila lábléc — modern marketplace-ek mintájára.
 * Brand logó + leírás bal oldalt, link-oszlopok jobb oldalt.
 */
export function Footer({
  brandName = 'Lectura',
  description,
  columns = [],
  copyright,
  className,
  ...props
}: FooterProps) {
  const year = new Date().getFullYear();
  return (
    <footer className={cn('bg-brand-deep text-white', className)} {...props}>
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo brandName={brandName} className="text-white" />
            {description ? (
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70">{description}</p>
            ) : null}
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8">
            {columns.map((column) => (
              <div key={column.title}>
                <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-white/90">
                  {column.title}
                </h4>
                <ul className="space-y-3 text-sm">
                  {column.links.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        className="text-white/70 transition-colors hover:text-white"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-white/60">
            {copyright ?? `© ${year} ${brandName}. Minden jog fenntartva.`}
          </p>
          <p className="text-xs text-white/40">
            EPUB 3.3 · Readium WebPub · OPDS 2.0
          </p>
        </div>
      </div>
    </footer>
  );
}
